var _desc, _defs, _rect, _rect2, _circle, _path, _rect3, _rect4, _path2, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SEO Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Search bar and growth graph visual.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#061b2d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 82,
    width: 472,
    height: 58,
    rx: 29,
    fill: "#114368",
    stroke: "#6cc6ff",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 111,
    r: 15,
    fill: "none",
    stroke: "#ffd700",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 121l12 12",
    stroke: "#ffd700",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 101,
    width: 198,
    height: 20,
    rx: 10,
    fill: "#2f7bab"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 176,
    width: 432,
    height: 126,
    rx: 14,
    fill: "#0b2f4b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 274l82-60 76 38 84-74 72 48",
    fill: "none",
    stroke: "#ffd700",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 274,
    r: 6,
    fill: "#ffd700"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 214,
    r: 6,
    fill: "#ffd700"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 252,
    r: 6,
    fill: "#ffd700"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 178,
    r: 6,
    fill: "#ffd700"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 226,
    r: 6,
    fill: "#ffd700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.91a8ade5a111becb1fdc18f032a77bc0.svg";
export { ForwardRef as ReactComponent };